export default __webpack_public_path__ + "static/media/woman-mobile.4c04d705.png";